var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRandom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3254 6.75L11.5001 0.5L0.674805 6.75V19.25L11.5001 25.5L22.3254 19.25V6.75ZM11.7607 12.1651C10.8651 12.9931 9.90012 13.8852 9.90012 15.3H12.6601C12.6601 14.5366 13.2922 13.9388 14.0081 13.2618C14.9427 12.3778 16.0201 11.3588 16.0201 9.66C16.0201 7.08 13.8001 5.72 11.5401 5.72C9.42012 5.72 7.52012 6.8 6.70012 8.82L9.06012 10.18C9.48012 9.1 10.2601 8.4 11.4401 8.4C12.6001 8.4 13.2601 8.94 13.2601 9.86C13.2601 10.7789 12.5364 11.448 11.7607 12.1651ZM9.58012 18.56C9.58012 19.5 10.3401 20.26 11.2801 20.26C12.2201 20.26 12.9801 19.5 12.9801 18.56C12.9801 17.62 12.2201 16.86 11.2801 16.86C10.3401 16.86 9.58012 17.62 9.58012 18.56Z",
    fill: props.fill
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRandom);
export default __webpack_public_path__ + "static/media/icon_random.f80809486f104456bfd3830ce4223336.svg";
export { ForwardRef as ReactComponent };